interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, currentPage - 2);
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  const btnBase =
    "flex h-9 min-w-9 items-center justify-center rounded-md border px-3 text-sm transition-colors";

  return (
    <nav className="mt-8 flex items-center justify-center gap-2" aria-label="分页">
      <button
        type="button"
        disabled={currentPage === 1}
        onClick={() => onChange(currentPage - 1)}
        className={`${btnBase} border-background-200 text-foreground-600 hover:border-secondary-300 hover:text-secondary-600 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line text-base"></i>
      </button>

      {start > 1 && (
        <>
          <button
            type="button"
            onClick={() => onChange(1)}
            className={`${btnBase} border-background-200 text-foreground-600 hover:border-secondary-300 hover:text-secondary-600`}
          >
            1
          </button>
          {start > 2 && <span className="px-1 text-foreground-400">…</span>}
        </>
      )}

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`${btnBase} ${
            page === currentPage
              ? "border-primary-600 bg-primary-600 text-background-50"
              : "border-background-200 text-foreground-600 hover:border-secondary-300 hover:text-secondary-600"
          }`}
        >
          {page}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="px-1 text-foreground-400">…</span>}
          <button
            type="button"
            onClick={() => onChange(totalPages)}
            className={`${btnBase} border-background-200 text-foreground-600 hover:border-secondary-300 hover:text-secondary-600`}
          >
            {totalPages}
          </button>
        </>
      )}

      <button
        type="button"
        disabled={currentPage === totalPages}
        onClick={() => onChange(currentPage + 1)}
        className={`${btnBase} border-background-200 text-foreground-600 hover:border-secondary-300 hover:text-secondary-600 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-right-s-line text-base"></i>
      </button>
    </nav>
  );
}